import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { actionTypes } from '../../../redux/actions/integrationsConnectionActions';

class PricingAgreement extends Component {
  agreeToPricing = () => {
    this.props.dispatch({
      type: actionTypes.UPDATE_PRICING,
      agreedToPricing: true,
    });
  };

  render() {
    return (
      <div className="kloudless-description-text">
        <p>
          PRICING: included in your Pro subscription is up to 250 PDF syncs every month to your desired service. Any PDF
          synced above the 250 limit incurs an overage charge of $0.25 per PDF. For larger volumes, please inquire about
          our discount pricing.
        </p>
        {this.props.showAgreeLink && (
          <div className="agree-btn">
            <Button bsSize="small" bsStyle="success" className="agree-btn" onClick={this.agreeToPricing}>
              I agree, let me continue
            </Button>
          </div>
        )}
      </div>
    );
  }
}

PricingAgreement.defaultProps = {
  showAgreeLink: false,
};

PricingAgreement.propTypes = {
  dispatch: PropTypes.func.isRequired,
  showAgreeLink: PropTypes.bool,
};

export default PricingAgreement;



// WEBPACK FOOTER //
// ./src/Integrations/connections/FilenameTemplate/PricingAgreement.jsx